<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    下水径站<br>
站点介绍<br>
下水径站位于深圳布吉镇吉华路北水径村路段地下，主体沿吉华路呈南北走向。车站南北方向划分为上水径村和下水径村，距深圳火车站6公里，南侧为布吉联检站。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:12	23:19	5号线	3分钟	5分25秒<br>
黄贝岭	06:16	00:02	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:24	23:19	5号线	4分钟	6分钟<br>
黄贝岭	06:10	00:02	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:24	00:19	5号线	4分钟	6分钟<br>
黄贝岭	06:10	01:02	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
吉华路西侧、下水径配客服站（米粒充电站）、大靓花园<br><br>
C出入口:<br>
吉华路东侧、啟元学校、下水径大厦、中南明珠大厦、水径派出所、下水径村委大楼、长龙苑、阳光花园、湖北宝丰工业区、景华·嶺莑<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 下水径<br>
M105、M267、M271、M272、M414、M415、303、307、308、312、381、980<br><br>
C出入口:<br>
公交站名： 下水径<br>
303、307、308、312、381、980、M414、M415、M267、M271、M272、M105、M565<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


